/* eslint-disable eslint-comments/no-restricted-disable */
/* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { clientSideOnly } from '@atlassian/jira-common-client-side-only/src/index.tsx';

export const servicedeskResolutionManagementEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(() =>
		clientSideOnly(
			import(
				/* webpackChunkName: "async-servicedesk-resolution-management-entrypoint" */ '@jira/jira-spa-apps-project-settings-service-desk-resolution-management/src/ui/ResolutionManagementView.tsx'
			).then((module) => module.default),
		),
	),
	getPreloadProps: () => ({}),
});
